import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

// Define a type for the slice state
const DEFAULT_HIDE_DURATION = 6000;

export interface AlertProps {
  open: boolean;
  severity: 'warning' | 'success' | 'error' | 'info';
  message: string | undefined;
  autoHideDuration: number;
}

// Define the initial state using that type
const initialState: AlertProps = {
  open: false,
  severity: 'info',
  message: 'A very important message to tell the world',
  autoHideDuration: DEFAULT_HIDE_DURATION,
};

export const alertSlice = createSlice({
  name: 'alert',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    alertError: (state, action: PayloadAction<string>) => {
      state.severity = 'error';
      state.open = true;
      state.message = action.payload;
    },
    alertInfo: (state, action: PayloadAction<string>) => {
      state.severity = 'info';
      state.open = true;
      state.message = action.payload;
    },
    alertWarning: (state, action: PayloadAction<string>) => {
      state.severity = 'warning';
      state.open = true;
      state.message = action.payload;
    },
    alertSuccess: (state, action: PayloadAction<string>) => {
      state.severity = 'success';
      state.open = true;
      state.message = action.payload;
    },
    hideAlert: (state) => {
      state.open = false;
    },
    setAutoHideDuration: (state, action: PayloadAction<number>) => {
      state.autoHideDuration = action.payload;
    },
  },
});

export const { alertError, alertInfo, alertWarning, alertSuccess, hideAlert, setAutoHideDuration } =
  alertSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectAlert = (state: RootState) => state.alert;

export default alertSlice.reducer;
